export default "__VITE_ASSET__C3DiZOmY__"